import React, { useEffect, useState } from 'react';
import { useTheme } from 'styled-components';
import { ContentTop, EmptyIcon, FormRoundSpan, FormRoundSpanContent } from '../../../components/ui/Content';
import { Body1, Body1PointerLink } from '../../../components/Font';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../app/hooks';
import { LoaderContainer, LoaderEnum, MiniLoader } from '../../../ui/Loader/MiniLoader';
import { EnterMail } from './EnterMail';
import { EnterMailCode } from './EnterMailCode';
import { Mail } from '../../../icon/Icon';
import { useSearchParams } from 'react-router-dom';
import { EnterPhone } from './Phone/EnterPhone';
import { IRegisterForm } from '../../../interface/Auth/frontend';

interface IPhoneMailProps {
	isDisabled?: boolean;
	registerForm?: IRegisterForm;
}

export const PhoneMail: React.FC<IPhoneMailProps> = ({ isDisabled, registerForm }) => {
	const Theme = useTheme();
	const { t } = useTranslation();
	const [editMail, setEditMail] = useState(false);
	const { isFetching, mail, mailSubmit } = useAppSelector(state => state.auth);
	const [searchParams] = useSearchParams();

	useEffect(() => {
		if (searchParams.get('token')) {
			return;
		}
	}, []);

	useEffect(() => {
		setEditMail(!mail);
	}, [mail]);

	return (
		<>
			<ContentTop />
			<EnterPhone isDisabled={isDisabled} registerForm={registerForm} />

			{mail && !editMail && !mailSubmit && (
				<FormRoundSpan>
					<FormRoundSpanContent>
						<Mail />
						<Body1 style={{ width: 'unset' }}>
							{t('auth.codeSend')} {mail}
						</Body1>
						<EmptyIcon />
					</FormRoundSpanContent>

					<Body1PointerLink
						style={{ marginLeft: '34px' }}
						onClick={() => {
							setEditMail(true);
						}}
					>
						{t('auth.change')}
					</Body1PointerLink>
				</FormRoundSpan>
			)}

			{(mailSubmit || editMail) && (
				<EnterMail isDisabled={isDisabled} edit={editMail && !!mail} onCancel={() => setEditMail(false)} />
			)}

			{mail && !mailSubmit && !editMail && <EnterMailCode />}

			{isFetching && (
				<LoaderContainer style={{ marginTop: '12px' }}>
					<MiniLoader color={Theme.color.indicator} size={LoaderEnum.small} />
				</LoaderContainer>
			)}
		</>
	);
};
